import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import LabeledCheckBox from 'admin/components/molecules/LabeledCheckBox';

const FormWrapper = styled.div`
  ${LabeledCheckBox} {
    display: inline;
  }
`;

const CheckOptions = ({
  id, options, onChangeQuery, isClear, initialSelectedOptions,
}) => {
  const [selectableOps, setSelectableOps] = useState(
    options.map(op => ({ option: op, checked: initialSelectedOptions.includes(op.value) }))
  );

  useEffect(() => {
    if (isClear) {
      setSelectableOps(options.map(op => ({ option: op, checked: false })));
      onChangeQuery(id, null);
    }
  }, [isClear, options]);

  const handleClick = (checked, option) => {
    const updated = selectableOps.map(op => (
      {
        option: op.option,
        checked: op.option === option ? checked : op.checked,
      }
    ));
    onChangeQuery(id, `[${updated.filter(u => u.checked).map(u => u.option.value).join(',')}]`);
    setSelectableOps(updated);
  };

  const rows = options.map((option, index) => (
    <LabeledCheckBox
      key={`option-${Math.random()}`}
      labelText={option.label}
      checked={selectableOps.length ? selectableOps[index].checked : false}
      setChecked={checked => handleClick(checked, option)}
    />
  ));

  return (
    <FormWrapper>
      {rows}
    </FormWrapper>
  );
};

CheckOptions.propTypes = {
  id: PropTypes.string.isRequired,
  options: PropTypes.array.isRequired,
  onChangeQuery: PropTypes.func.isRequired,
  isClear: PropTypes.bool.isRequired,
};

export default CheckOptions;
